// extracted by mini-css-extract-plugin
export default {"question":"AssessmentAnswerComponent_question__uKiF3","buttons":"AssessmentAnswerComponent_buttons__WfM9S","page":"AssessmentAnswerComponent_page__-2Dp0"};